import getSiteTemplateSlug from './get-site-template-slug';
import getConceptOrBuildSlug from './get-concept-or-build-slug';

export default {
  getSiteTemplateSlug,
  getConceptOrBuildSlug,
};
